import React, { useMemo } from "react";

// SE-858 / future: inventory PDF signature tags — uncomment imports + block below to restore UI toggles
// import { useTranslation } from "react-i18next";
// import { PdfViewerSignatureSection, PdfViewerSignatureTagOption } from "./styles";
import { JobInventoryPDF } from "Models/job.inventory.pdf";
import { PDFViewer } from "../../PDFViewer";

interface PDFViewerProps {
  inventoryPdf?: JobInventoryPDF;
  onDocumentLoadSuccess?: (numPages: number) => void;
  onUpdateInventoryPdf?: (record: Partial<JobInventoryPDF>) => void;
}

const PDFViewerComponent: React.FC<PDFViewerProps> = ({
  inventoryPdf,
  onDocumentLoadSuccess: _onDocumentLoadSuccess,
  onUpdateInventoryPdf: _onUpdateInventoryPdf,
}) => {
  // const { t: translate } = useTranslation();

  const file = useMemo(() => {
    return inventoryPdf?.file || inventoryPdf?.url || null;
  }, [inventoryPdf]);

  return (
    <div>
      <PDFViewer
        filename={inventoryPdf?.file?.name || inventoryPdf?.filename}
        file={file}
        height={340}
      />

      {/* SE-858 / future: inventory PDF signature tags — uncomment to restore UI toggles
      <PdfViewerSignatureSection>
        <div className="tag-badge">{translate("tags")}</div>
        <PdfViewerSignatureTagOption
          active={!!inventoryPdf?.isCustomerNameRequired}
          onClick={() =>
            onUpdateInventoryPdf?.({
              ...inventoryPdf,
              isCustomerNameRequired: !inventoryPdf?.isCustomerNameRequired,
            })
          }
        >
          <span>{translate("customerName")}</span>
        </PdfViewerSignatureTagOption>
        <PdfViewerSignatureTagOption
          active={!!inventoryPdf?.isCustomerSignatureRequired}
          onClick={() =>
            onUpdateInventoryPdf?.({
              ...inventoryPdf,
              isCustomerSignatureRequired: !inventoryPdf?.isCustomerSignatureRequired,
            })
          }
        >
          <span>{translate("customerSignature")}</span>
        </PdfViewerSignatureTagOption>
        <PdfViewerSignatureTagOption
          active={!!inventoryPdf?.isRemovalistNameRequired}
          onClick={() =>
            onUpdateInventoryPdf?.({
              ...inventoryPdf,
              isRemovalistNameRequired: !inventoryPdf?.isRemovalistNameRequired,
            })
          }
        >
          <span>{translate("removalistName")}</span>
        </PdfViewerSignatureTagOption>
        <PdfViewerSignatureTagOption
          active={!!inventoryPdf?.isRemovalistSignatureRequired}
          onClick={() =>
            onUpdateInventoryPdf?.({
              ...inventoryPdf,
              isRemovalistSignatureRequired: !inventoryPdf?.isRemovalistSignatureRequired,
            })
          }
        >
          <span>{translate("removalistSignature")}</span>
        </PdfViewerSignatureTagOption>
        <PdfViewerSignatureTagOption
          active={!!inventoryPdf?.isDateRequired}
          onClick={() =>
            onUpdateInventoryPdf?.({
              ...inventoryPdf,
              isDateRequired: !inventoryPdf?.isDateRequired,
            })
          }
        >
          <span>{translate("date")}</span>
        </PdfViewerSignatureTagOption>
      </PdfViewerSignatureSection>
      */}
    </div>
  );
};

export { PDFViewerComponent };
